import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#year-in-review-double_svg__a)">
      <path fill="currentColor" d="M12 20.448A8.449 8.449 0 1 0 12 3.55a8.449 8.449 0 0 0 0 16.898Z" />
    </g>
    <defs>
      <clipPath id="year-in-review-double_svg__a">
        <path fill="#fff" d="M3.2 3.2h17.6v17.6H3.2z" />
      </clipPath>
    </defs>
  </svg>
);
